import { useMutation, useQueryClient } from "@tanstack/react-query";
import { deleteCrm } from ".";
import { queryKeys } from "@/lib/useQuery/queryKeys";

export function useDeleteCrm() {
    const queryClient = useQueryClient();
    return useMutation({
        mutationKey: queryKeys.crm._def,
        mutationFn: deleteCrm,
        onSuccess: () => {
            queryClient.invalidateQueries({queryKey: queryKeys.crm._def, exact: false});
        }
    });
}
